// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"PopupItem__Wrapper_3UCDJ grid","Title":"PopupItem__Title_1QrhA","List":"PopupItem__List_c0HUr grid","Name":"PopupItem__Name_1gXKj"};